var utils = require("./utils");
var Popup = require("./Popup");

window.popupInstance = new Popup({
  licenseId: utils.getLicenseFromURL(window.location.href)
});
window.popupInstance.init();
